import { render, staticRenderFns } from "./exhibition-car-no.vue?vue&type=template&id=15fabb8e&scoped=true&"
import script from "./exhibition-car-no.vue?vue&type=script&lang=js&"
export * from "./exhibition-car-no.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-car-no.vue?vue&type=style&index=0&id=15fabb8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fabb8e",
  null
  
)

export default component.exports